import { z } from "zod"

export const createSchema = z.object({
  display_name: z.string().min(3, { message: 'Tamanho minimo: 3 characteres' }).max(64, { message: 'Tamanho máximo: 64 characteres' })
})

export type ProductCategoryValidationSchema = z.infer<typeof createSchema>